export const USER_PROFILE_DEFUALT_ID = '00000000-0000-0000-0000-000000000001';
export const USER_PROFILE_DEFUALT_USERNAME = 'Guest';
export const USER_PROFILE_UNKNOWN_NAME = 'Unknown';